import './message.css'
import MessageTip from './Message'
import Vue from 'vue'

const MainConstructor = Vue.extend(MessageTip)

function isVNode(node) {
	return node !== null && typeof node === 'object'
}

let count = 1
let instances = []
let instance

const Message = function(options = {}) {
	if (typeof options === 'string') {
		options = {
			content: options,
		}
	}
	const onMessageClose = options.onClose
	const id = 'message_' + count++

	options.onClose = function() {
		Message.close(id, onMessageClose)
	}

	instance = new MainConstructor({
		data: options,
	})

	instance.id = id
	instance.vm = instance.$mount()
	document.body.appendChild(instance.vm.$el)
	instance.vm.visible = true
	instance.dom = instance.vm.$el
	instances.push()
	// message 已render的形式传入
	if (isVNode(instance.message)) {
		instance.$slots.default = [instance.message]
		instance.message = null
	}

	return instance.vm
}

;['info', 'success', 'warning', 'error'].forEach(type => {
	Message[type] = options => {
		if (typeof options === 'string') {
			options = {
				message: options,
			}
		}
		options.type = type
		return Message(options)
	}
})

Message.onClose = (id, onMessageClose) => {
	for (let i = 0, len = instances.length; i < len; i++) {
		if (id === instances[i].id) {
			if (typeof onMessageClose === 'function') {
				onMessageClose(instances[i])
			}
			instances.splice(i, 1)
			break
		}
	}
}

Message.closeAll = onMessageClose => {
	for (let i = 0, len = instances.length; i < len; i++) {
		if (typeof onMessageClose === 'function') {
			onMessageClose(instances[i])
		}
	}
	instances = []
}

Message.install = Vue => {
	Vue.prototype.$message = Message
}
export default Message
